import * as types from './actionTypes'

export const initRecord = (entity, recordId) => ({
    type: types.FETCH_RECORD,
    entity,
    recordId
})

export const recordSuccess = (data) => ({
    type: types.FETCH_RECORD_SUCCESS,
    data
})

export const recordFailed = () => ({
    type: types.FETCH_RECORD_FAILED
})

export const updateRecord = (recordId, fieldId, value) => ({
    type: types.UPDATE_RECORD,
    recordId,
    fieldId,
    value
})

export const duplicateRecord = () => ({
    type: types.DUPLICATE_RECORD
})

export const duplicateRecordSuccess = (data) => ({
    type: types.DUPLICATE_RECORD_SUCCESS,
    data
})

export const duplicateRecordFailed = () => ({
    type: types.DUPLICATE_RECORD_FAILED
})

export const deleteRecord = (ids) => ({
    type: types.DELETE_RECORD,
    ids
})

export const deleteRecordSuccess = (data) => ({
    type: types.DELETE_RECORD_SUCCESS,
    data
})

export const deleteRecordFailed = () => ({
    type: types.DELETE_RECORD_FAILED
})

export const resetRecord = () => ({
    type: types.RESET_RECORD
})
